// Entrypoint for all exports shared by the browser and node bundles.
/***********************************************************************************
 *      DO NOT PUT ANYTHING IN THIS FILE THAT CANNOT BE USED BY ALL BUNDLES!       *
 ***********************************************************************************
 * I'll make this easy to remember. Keep this station clear, or I WILL _KEAL_ YOU! *
 ***********************************************************************************/
import type {} from '@emotion/styled'; // Necessary to prevent TS declaration build errors when using styled from @mui/material
import type {} from '@mui/lab/themeAugmentation'; // Necessary to use theme augmentation on lab components
import type {} from '@mui/x-data-grid-premium/themeAugmentation'; // Necessary to use theme augmentation on datagrid components
import type {} from '@mui/x-date-pickers-pro/themeAugmentation'; // Necessary to use theme augmentation on datepicker components

import muiInfo from '@mui/material/package.json';
import { createFilterOptions } from '@mui/material/useAutocomplete';

import defaultTheme from 'src/styles/themes/default/defaultTheme';
import wkTheme from 'src/wsd/styles/theme/wkTheme';
import { setMuiProLicense } from './utils/muiLicenseUtils';

setMuiProLicense();

export {
  styled,
  useColorScheme,
  useMediaQuery,
  useTheme,
  type SxProps,
  type Theme,
  type CSSObject,
  Unstable_Grid2 as GridV2,
} from '@mui/material';
export { debounce } from '@mui/material/utils';
export {
  alpha,
  darken,
  decomposeColor,
  emphasize,
  getContrastRatio,
  getLuminance,
  hexToRgb,
  hslToRgb,
  lighten,
  recomposeColor,
  rgbToHex,
} from '@mui/material/styles';
export { visuallyHidden } from '@mui/utils';

export * from 'src/components/Accordion/index';
export * from 'src/components/AccordionActions/index';
export * from 'src/components/AccordionDetails/index';
export * from 'src/components/AccordionSummary/index';
export * from 'src/components/Alert/index';
export * from 'src/components/AlertAction/index';
export * from 'src/components/AlertTitle/index';
export * from 'src/components/AppBar/index';
export * from 'src/components/Autocomplete/index';
export * from 'src/components/Avatar/index';
export * from 'src/components/AvatarGroup/index';
export * from 'src/components/Backdrop/index';
export * from 'src/components/Badge/index';
export * from 'src/components/Box/index';
export * from 'src/components/BreadcrumbNav/index';
export * from 'src/components/Breadcrumbs/index';
export * from 'src/components/Button/index';
export * from 'src/components/ButtonBase/index';
export * from 'src/components/ButtonGroup/index';
export * from 'src/components/ButtonToolbar/index';
export * from 'src/components/Card/index';
export * from 'src/components/CardActionArea/index';
export * from 'src/components/CardActions/index';
export * from 'src/components/CardContent/index';
export * from 'src/components/CardHeader/index';
export * from 'src/components/CardMedia/index';
export * from 'src/components/Checkbox/index';
export * from 'src/components/Chip/index';
export * from 'src/components/ClickAwayListener/index';
export * from 'src/components/CircularProgress/index';
export * from 'src/components/Collapse/index';
export * from 'src/components/Container/index';
export * from 'src/components/CssBaseline/index';
export * from 'src/components/Dialog/index';
export * from 'src/components/DialogActions/index';
export * from 'src/components/DialogContent/index';
export * from 'src/components/DialogContentText/index';
export * from 'src/components/DialogTitle/index';
export * from 'src/components/DialogTrigger/index';
export * from 'src/components/Divider/index';
export * from 'src/components/Drawer/index';
export * from 'src/components/DropdownButton/index';
export * from 'src/components/EmptyView/index';
export * from 'src/components/Fab/index';
export * from 'src/components/Fade/index';
export * from 'src/components/FileListItem/index';
export * from 'src/components/FileUploader/index';
export * from 'src/components/FilledInput/index';
export * from 'src/components/FormControl/index';
export * from 'src/components/FormControlLabel/index';
export * from 'src/components/FormGroup/index';
export * from 'src/components/FormHelperText/index';
export * from 'src/components/FormLabel/index';
export * from 'src/components/Grid/index';
export * from 'src/components/Grow/index';
export * from 'src/components/Icon/index';
export * from 'src/components/IconButton/index';
export * from 'src/components/Input/index';
export * from 'src/components/InputAdornment/index';
export * from 'src/components/InputBase/index';
export * from 'src/components/InputLabel/index';
export * from 'src/components/InteractivePaper/index';
export * from 'src/components/LinearProgress/index';
export * from 'src/components/Link/index';
export * from 'src/components/ListItem/index';
export * from 'src/components/ListItemAvatar/index';
export * from 'src/components/ListItemButton/index';
export * from 'src/components/ListItemIcon/index';
export * from 'src/components/ListItemSecondaryAction/index';
export * from 'src/components/ListItemSecondaryActions/index';
export * from 'src/components/ListItemText/index';
export * from 'src/components/ListSubheader/index';
export * from 'src/components/LoadingButton/index';
export * from 'src/components/lockable/LockableTextField/index';
export * from 'src/components/Masonry/index';
export * from 'src/components/Menu/index';
export * from 'src/components/MenuItem/index';
export * from 'src/components/MenuList/index';
export * from 'src/components/MobileStepper/index';
export * from 'src/components/Modal/index';
export * from 'src/components/NestedUnifyThemeProvider/index';
export * from 'src/components/NoSsr/index';
export * from 'src/components/OutlinedInput/index';
export * from 'src/components/Pagination/index';
export * from 'src/components/PaginationItem/index';
export * from 'src/components/Paper/index';
export * from 'src/components/PaperActionArea/index';
export * from 'src/components/Popover/index';
export * from 'src/components/PopoverTrigger/index';
export * from 'src/components/Popper/index';
export * from 'src/components/PopperTrigger/index';
export * from 'src/components/Portal/index';
export * from 'src/components/Radio/index';
export * from 'src/components/RadioGroup/index';
export * from 'src/components/ScopedCssBaseline/index';
export * from 'src/components/Select/index';
export * from 'src/components/SelectableCard/index';
export * from 'src/components/Skeleton/index';
export * from 'src/components/Slide/index';
export * from 'src/components/Slider/index';
export * from 'src/components/Snackbar/index';
export * from 'src/components/SnackbarContent/index';
export * from 'src/components/Stack/index';
export * from 'src/components/Step/index';
export * from 'src/components/StepButton/index';
export * from 'src/components/StepConnector/index';
export * from 'src/components/StepContent/index';
export * from 'src/components/StepLabel/index';
export * from 'src/components/Stepper/index';
export * from 'src/components/SvgIcon/index';
export * from 'src/components/SwipeableDrawer/index';
export * from 'src/components/Switch/index';
export * from 'src/components/Tab/index';
export * from 'src/components/TabContext/index';
export * from 'src/components/TabScrollButton/index';
export * from 'src/components/Table/index';
export * from 'src/components/TableBody/index';
export * from 'src/components/TableCell/index';
export * from 'src/components/TableContainer/index';
export * from 'src/components/TableFooter/index';
export * from 'src/components/TableHead/index';
export * from 'src/components/TablePagination/index';
export * from 'src/components/TableRow/index';
export * from 'src/components/TableSortLabel/index';
export * from 'src/components/TabList/index';
export * from 'src/components/TabPanel/index';
export * from 'src/components/Tabs/index';
export * from 'src/components/TextareaAutosize/index';
export * from 'src/components/TextField/index';
export * from 'src/components/ThemeProvider/index';
export * from 'src/components/ToggleButton/index';
export * from 'src/components/ToggleButtonGroup/index';
export * from 'src/components/Toolbar/index';
export * from 'src/components/Tooltip/index';
export * from 'src/components/transitions/index';
export * from 'src/components/Typography/index';
export {
  WorkivaDocumentIcon,
  WorkivaFlowchartIcon,
  WorkivaPresentationIcon,
  WorkivaSpreadsheetIcon,
} from 'src/components/UnifyIcons/custom/suite_icons';
export * from 'src/components/WsdThemeProvider/index';
export * from 'src/components/UnifyList/index';
export * from 'src/components/UnifyThemeProvider/index';
export * from 'src/components/Zoom/index';
export * from 'src/components/GlobalStyles/index';

export type { default as OverlayActionApi } from 'src/components/OverlayTrigger/OverlayActionApi';
export {
  configureGlobalUnifyLocale,
  localeSettings,
} from 'src/localization/configLocale';
export { default as createTheme } from 'src/styles/createTheme';
// eslint-disable-next-line deprecation/deprecation
export { getThemePalette } from 'src/styles/utils';
export { useCharacterCounter } from 'src/components/TextField/TextField';
export { getToken } from '@workiva/unify-tokens';
export { default as RemValue } from 'src/utils/rem_value';
export { default as themeSpacingAsRem } from 'src/utils/theme_spacing_as_rem';
export { useLegacyWsdStyles } from 'src/wsd/styles/context/useLegacyWsdStyles';
// eslint-disable-next-line deprecation/deprecation
export { createFilterOptions, defaultTheme, version, wkTheme };
const version = muiInfo.version;
